import Section from 'src/ui/atoms/section';
import styled from 'styled-components';

export const RightAlignedElement = styled(Section)`
  margin-right: 2rem;
`;
